import { wantsTouchControls } from "./detect.js";

/**
 * ¿Corre dentro de la app nativa (Capacitor)?
 *
 * Se mira el objeto global que inyecta el puente en vez de importar
 * `@capacitor/core`: asi la web no carga ni un byte de Capacitor, y la app
 * responde igual. (La rama `capacitor-android` tiene la misma funcion en
 * `fullscreen.ts`; al unirlas sobra una de las dos.)
 */
export function isNativeApp(): boolean {
  if (typeof window === "undefined") return false;
  const cap = (window as Window & { Capacitor?: { isNativePlatform?: () => boolean } }).Capacitor;
  return cap?.isNativePlatform?.() === true;
}

/**
 * ¿Se puede jugar a dos en este dispositivo?
 *
 * Solo en el NAVEGADOR (decision del usuario, 2026-09-28: en la app no) y con
 * teclado: hacen falta dos manos por jugador o un mando cada uno, y en un movil
 * o una tablet tactil no hay ni lo uno ni lo otro.
 */
export function localPairAvailable(): boolean {
  return !isNativeApp() && !wantsTouchControls();
}
